(function () {
	'use strict';

	angular
		.module('app.core')
		.directive('activityFeed', activityFeed);

	function activityFeed() {
		var directive = {
			restrict: 'EA',
			templateUrl: 'core/activity-feed/activity-feed.html',
			scope: {
				projectNdx: '=',
				factoryNdx: '=',
				simpleFeed: '@',
				hideShowMore: '@',
				activityLimit: '@',
				showProjectHelpLink: '@',
				hideHeader: '@'
			},
			controller: activityFeedCtrl,
			controllerAs: 'activityCtrl',
			bindToController: true
		};

		return directive;
	}

	activityFeedCtrl.$inject = ['$rootScope', '$scope', 'editProjectService'];

	function activityFeedCtrl($rootScope, $scope, editProjectService) {
		var vm = this;
		this.$onInit = function () {
			vm.simpleFeed = vm.simpleFeed ? vm.simpleFeed === 'true' : false;
			vm.hideShowMore = vm.hideShowMore ? vm.hideShowMore === 'true' : false;
			vm.activityLimit = vm.activityLimit ? parseInt(vm.activityLimit) : 5;
			vm.showProjectHelpLink = vm.showProjectHelpLink ? vm.showProjectHelpLink === 'true' : false;
			init();
		};
		vm.toggleActivityText = 'Show More Activity';
		vm.showMoreActivity = false;
		vm.toggleActivity = toggleActivity;
		
		function init() {
			if (vm.projectNdx && vm.factoryNdx) {
				editProjectService.getActivity(vm.projectNdx, vm.factoryNdx, vm.simpleFeed).then(function (response) {
					vm.activity = response;
					vm.empty = !vm.activity || !vm.activity.length;
					vm.loading = false;
					vm.moreActivity = !vm.empty && vm.activity.length > vm.activityLimit;
				});
			}
		}

		function toggleActivity() {
			vm.showMoreActivity = !vm.showMoreActivity;
			if (vm.showMoreActivity) {
				vm.toggleActivityText = 'Show Less Activity';
			} else {
				vm.toggleActivityText = 'Show More Activity';
			}
		}

		var activityListener = $rootScope.$on('activityUpdated', function () {
			init();
		});
		$scope.$on('$destroy', function() {
			activityListener();
		});
	}

})();
